// extracted by mini-css-extract-plugin
export var cancelButton = "_n1-5";
export var content = "_n1-3";
export var createButton = "_n1-6";
export var drawerContainer = "_n1-0";
export var footer = "_n1-2";
export var header = "_n1-1";
export var orderFormColumn = "_n1-4";